import { ReverseRemitParams } from "us.collection.economy/interfaces/RemitHistory/remitHistory";

export function ReverseRemit(this: any): ReverseRemitParams {
  return {
    comment: this.comment,
  };
}
